enum QualityControlStatus {
  TO_DO = 'TO_DO',
  NOT_CHECKED = 'NOT_CHECKED',
  ONGOING = 'ONGOING',
  PASSED = 'PASSED',
  NOT_OK = 'NOT_OK',
}

export default QualityControlStatus;